import React from "react";
import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  InputGroup,
  InputLeftAddon
} from "@chakra-ui/react";

export const FormInputWithAddons = ({
  label,
  type,
  formProps = {},
  value,
  inputOnChange,
  name,
  padding = { base: "0 10px 10px 0", md: "0 20px 20px 0" },
  readOnly,
  errorMessage = "",
  accept = "",
  resourceRef,
  isDisabled,
  inputProps = {},
  placeholder="",
  leftAddon
}) => {
  return (
    <FormControl padding={padding} colorScheme="brand" {...formProps}>
      <FormLabel
        fontSize="15px"
        textTransform="capitalize"
        fontWeight={600}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <InputLeftAddon>{leftAddon}</InputLeftAddon>
        <Input
          type={type}
          fontSize="15px"
          placeholder={placeholder || label}
          value={type !== "file" ? value || "" : value}
          onChange={inputOnChange}
          errorBorderColor="red.300"
          name={name}
          readOnly={readOnly}
          accept={accept}
          ref={resourceRef}
          isDisabled={isDisabled}
          {...inputProps}
        />
        <FormErrorMessage display="block">{errorMessage}</FormErrorMessage>
      </InputGroup>
    </FormControl>
  );
};
